import React, { useState, useEffect, useMemo, useCallback } from "react"
import { Table, Col, Row } from "reactstrap"
import api from "API/Api"
import { Link } from "react-router-dom"
import SweetAlert from "react-bootstrap-sweetalert"
import loader from "./../../assets/loading/loader.gif"
import { AuthUser } from "API/UserAccess"
import { usePermissions } from "API/PermissionContext"

const Users = () => {
  const { canAdd, canDelete, MODULE } = usePermissions()
  const MID = MODULE.ROLES_USERS
  const [users, setUsers] = useState([])
  const [dataLoaded, setDataLoaded] = useState(false)
  const [checkedItems, setCheckedItems] = useState({})
  const [parentChecked, setParentChecked] = useState(false)
  const [confirm_alert, setconfirm_alert] = useState(false)
  const [confirm_multiple_alert, setconfirm_multiple_alert] = useState(false)
  const [success_dlg, setsuccess_dlg] = useState(false)
  const [dynamic_title, setdynamic_title] = useState("")
  const [dynamic_description, setdynamic_description] = useState("")
  const [deleteId, setDeleteId] = useState("")
  const [search, setSearch] = useState({ name: "", email: "", username: "", role: "", accessLevel: "" })
  const [showFilter, setShowFilter] = useState(false)

  const fetchData = useCallback(async () => {
    try {
      const response = await api.get("added-users/" + (AuthUser?.uid || AuthUser?.id || 0))
      const d = Array.isArray(response.data.data) ? response.data.data : response.data.data?.data || []
      setUsers(d)
    } catch (err) { console.error(err) }
    setDataLoaded(true)
  }, [])

  useEffect(() => { fetchData() }, [fetchData])

  const handleDelete = async () => {
    try { await api.post("delete-multiple-user", { items: [deleteId] }); fetchData() } catch (err) { console.error(err) }
  }
  const handleMultiDelete = async () => {
    const ids = Object.keys(checkedItems).filter(k => checkedItems[k])
    if (!ids.length) return
    try { await api.post("delete-multiple-user", { items: ids }); setCheckedItems({}); setParentChecked(false); fetchData() } catch (err) { console.error(err) }
  }

  const handleCheckbox = id => {
    setCheckedItems(prev => {
      const n = { ...prev, [id]: !prev[id] }
      setParentChecked(users.length > 0 && users.every(u => n[u.id]))
      return n
    })
  }
  const handleParentCheckbox = () => {
    const n = !parentChecked; setParentChecked(n)
    const items = {}; users.forEach(u => { items[u.id] = n }); setCheckedItems(items)
  }
  const selectedCount = Object.values(checkedItems).filter(Boolean).length

  // Get unique access levels for filter dropdown
  const uniqueLevels = useMemo(() => {
    const set = new Set()
    users.forEach(u => { if (u.access_level) set.add(u.access_level) })
    return [...set].sort()
  }, [users])

  const filtered = useMemo(() => {
    return users.filter(item => {
      return (item.name || "").toLowerCase().includes(search.name.toLowerCase()) &&
        (item.email || "").toLowerCase().includes(search.email.toLowerCase()) &&
        (item.username || "").toLowerCase().includes(search.username.toLowerCase()) &&
        (item.roleName || "").toLowerCase().includes(search.role.toLowerCase()) &&
        (item.access_level || "").toString().toLowerCase().includes(search.accessLevel.toLowerCase())
    })
  }, [users, search])

  const removeFilter = () => {
    setSearch({ name: "", email: "", username: "", role: "", accessLevel: "" })
    setShowFilter(!showFilter)
  }

  const LEVEL_COLORS = {
    "Admin": "#dc2626", "Company": "#6366f1", "Plant": "#0ea5e9",
    "CC": "#22c55e", "Route": "#f59e0b", "Center": "#8b5cf6", "Client": "#6c757d",
  }

  return (
    <>
      <div className="dashBody">
        {canDelete(MID) && selectedCount > 0 && (
          <button className="delete-button" onClick={() => setconfirm_multiple_alert(true)}>
            <i className="fa fa-trash"></i> <span className="badge bg-white text-danger ms-1">{selectedCount}</span>
          </button>
        )}
        <button className="filter_rel btn btn-primary" onClick={removeFilter}>
          <i className="fa fa-filter"></i>
          {showFilter && <i className="rel_filter_ban fa fa-ban"></i>}
        </button>
        <div className="font-size-18 mb-0 dashHeader">
          <Row>
            <Col md={6}><h4>Users</h4></Col>
            <Col md={6} style={{ textAlign: "right" }}>
              {canAdd(MID) && <Link className="dashBtn" to="/add-user"><i className="fas fa-plus-square"></i> <b>Add New</b></Link>}
            </Col>
          </Row>
        </div>
        <div className="table-responsive">
          <Table className="table mb-0 dairyTbl">
            <thead>
              <tr>
                <th><input type="checkbox" checked={parentChecked} onChange={handleParentCheckbox} /></th>
                <th>S.No</th>
                <th>Name</th>
                <th>Email</th>
                <th>Username</th>
                <th>Role</th>
                <th>Access Level</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {showFilter && (
                <tr>
                  <td></td><td></td>
                  <td><input type="text" className="form-control form-control-sm" placeholder="Name..."
                    value={search.name} onChange={e => setSearch(s => ({ ...s, name: e.target.value }))} /></td>
                  <td><input type="text" className="form-control form-control-sm" placeholder="Email..."
                    value={search.email} onChange={e => setSearch(s => ({ ...s, email: e.target.value }))} /></td>
                  <td><input type="text" className="form-control form-control-sm" placeholder="Username..."
                    value={search.username} onChange={e => setSearch(s => ({ ...s, username: e.target.value }))} /></td>
                  <td><input type="text" className="form-control form-control-sm" placeholder="Role..."
                    value={search.role} onChange={e => setSearch(s => ({ ...s, role: e.target.value }))} /></td>
                  <td>
                    <select className="form-control form-control-sm" value={search.accessLevel}
                      onChange={e => setSearch(s => ({ ...s, accessLevel: e.target.value }))}>
                      <option value="">All</option>
                      {uniqueLevels.map((lvl, i) => <option key={i} value={lvl}>{lvl}</option>)}
                    </select>
                  </td>
                  <td></td>
                </tr>
              )}
              {!dataLoaded ? (
                <tr><td colSpan={8}><img className="loaderImg" src={loader} alt="Loading" /></td></tr>
              ) : filtered.length > 0 ? (
                filtered.map((user, i) => {
                  const color = LEVEL_COLORS[user.access_level] || "#6c757d"
                  return (
                    <tr key={user.id}>
                      <td><input type="checkbox" checked={!!checkedItems[user.id]} onChange={() => handleCheckbox(user.id)} /></td>
                      <td>{i + 1}</td>
                      <td style={{ fontWeight: "600" }}>{user.name}</td>
                      <td>{user.email}</td>
                      <td>{user.username}</td>
                      <td>{user.roleName || "-"}</td>
                      <td>
                        <span style={{
                          background: color + "15", color, padding: "3px 10px",
                          borderRadius: "12px", fontSize: "12px", fontWeight: "600",
                          border: `1px solid ${color}30`
                        }}>
                          {user.access_level || "-"}
                        </span>
                      </td>
                      <td>
                        {canDelete(MID) && <i className="fas fa-trash-alt icons icon-delete"
                          onClick={() => { setDeleteId(user.id); setconfirm_alert(true) }}></i>}
                      </td>
                    </tr>
                  )
                })
              ) : (
                <tr><td colSpan={8} className="text-center py-4">
                  <i className="fas fa-users fa-2x text-muted mb-2 d-block"></i>No users found
                </td></tr>
              )}
            </tbody>
          </Table>
        </div>
      </div>

      {confirm_alert && (
        <SweetAlert title="Are you sure?" warning showCancel confirmBtnBsStyle="success" cancelBtnBsStyle="danger"
          onConfirm={() => { handleDelete(); setconfirm_alert(false); setsuccess_dlg(true); setdynamic_title("Deleted"); setdynamic_description("User deleted.") }}
          onCancel={() => setconfirm_alert(false)}>You won't be able to revert this!</SweetAlert>
      )}
      {confirm_multiple_alert && (
        <SweetAlert title={`Delete ${selectedCount} users?`} warning showCancel confirmBtnBsStyle="success" cancelBtnBsStyle="danger"
          onConfirm={() => { handleMultiDelete(); setconfirm_multiple_alert(false); setsuccess_dlg(true); setdynamic_title("Deleted"); setdynamic_description("Selected users deleted.") }}
          onCancel={() => setconfirm_multiple_alert(false)}>You won't be able to revert this!</SweetAlert>
      )}
      {success_dlg && (
        <SweetAlert success title={dynamic_title} onConfirm={() => setsuccess_dlg(false)}>{dynamic_description}</SweetAlert>
      )}
    </>
  )
}

export default Users
